
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.311 11.591a8.468 8.468 0 00-16.622 0 5.802 5.802 0 10.538 11.591h.907a.682.682 0 000-1.364h-.907a4.431 4.431 0 11-.068-8.863l.682.157.089-.75a7.098 7.098 0 0114.086 0l.136.736.682-.143a4.432 4.432 0 11-.068 8.863h-1.023a.682.682 0 000 1.364h1.03a5.802 5.802 0 00.538-11.59z"}}),_c('path',{attrs:{"d":"M15.483 14.073a.682.682 0 00-.968 0l-3.852 3.852a.68.68 0 000 .968.682.682 0 00.961 0l2.693-2.693v8.346a.682.682 0 101.364 0V16.2l2.727 2.693a.682.682 0 00.961-.968l-3.886-3.852z"}})])
          )
        }
      }
    